export default {
  setFeedback(state, feedback) {
    state.feedback = feedback
  },
}
